import { render, staticRenderFns } from "./Identity_Layout.vue?vue&type=template&id=034f7173&scoped=true&"
import script from "./Identity_Layout.vue?vue&type=script&lang=js&"
export * from "./Identity_Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034f7173",
  null
  
)

export default component.exports